import React from "react";
import { styled } from "@mui/material/styles";
import Modal from "@mui/material/Modal";
import "./ProposalModal.css";
import closeIcon from "../assets/icons/Buttons-Close.png";
import { Proposals } from "../containers/Proposals";
 
const Paper = styled("div")(({ theme }) => ({
  position: "absolute",
  width: "90%",
  backgroundColor: "#ccc",
  border: "1px solid #000",
  boxShadow: theme.shadows[5],
  height: "90%",
  maxHeight: "87%",
  overflow: "auto",
}));
 
function getModalStyle() {
  const top = 50;
  const left = 50;
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
 
export default function FocusAreaModel(props) {
  const [modalStyle] = React.useState(getModalStyle);
  const body = (
    <Paper style={modalStyle} className="AdminProposalModal">
      <div className="ModalcloseIcon">
        <img
          className="propose-closeIcon"
          src={closeIcon}
          onClick={props.handleClose}
          alt="close"
        />
      </div>
      <Proposals
        activeRecordParams={props.activeRecordParams}
        edit={props.edit}
        newFA={props.newFA}
        readonlyFA={props.readonlyFA}
        submitable={props.submitable}
        userInfo={props.userInfo}
        onClose={props.handleClose}
        loadAdminData={props.loadAdminData}
        langInfo={props.langInfo}
        rowData={props.rowData}
      />
    </Paper>
  );
 
  return (
    <div>
      <Modal
        open={props.open}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ outline: 0, backgroundColor: "rgba(0, 0, 0, 0.8)" }}
      >
        {body}
      </Modal>
    </div>
  );
}
 